import { Link, useLocation } from "react-router-dom";

import  { routes } from '../util/routes'
import { useIntl } from "react-intl";

export const Breadcrumbs = () => {
    const location = useLocation();
    const intl = useIntl();

    const getBreadcrumbData = () => {
        if (location.pathname === "/") {
            const currentRoute = Object.values(routes).find((route) => {
                return route.path === "/";
            }
            );
            const breadcrumbLabel =
                currentRoute && currentRoute.renderBreadcrumb
                    ? currentRoute.renderBreadcrumb(location.state)
                    : location.pathname;

            return (
                <li className="breadcrumb-item active" aria-current="page">{breadcrumbLabel}</li>
            );
        }

        const crumbNames = location.pathname.split("/").filter(crumb => crumb);

        return crumbNames.map( (crumb: string, index: number) => {
            const breadcrumbPath = `/${crumbNames.slice(0, index + 1).join('/')}`;
            const isLast = index === crumbNames.length - 1;
            const currentRoute = Object.values(routes).find((route) => {
                return route.path === breadcrumbPath;
            }
            );
            const breadcrumbLabel =
                currentRoute && currentRoute.renderBreadcrumb
                    ? currentRoute.renderBreadcrumb(location.state)
                    : crumb;

            return (
                isLast
                    ? <li key={index} className="breadcrumb-item active" aria-current="page">{breadcrumbLabel}</li>
                    : <li key={index} className="breadcrumb-item "><Link to={breadcrumbPath}>{breadcrumbLabel}</Link></li>
            );
        })
    }


    return (
        <div className="breadcrumb-wrp">
            <nav id="breadcrumb" aria-label={ intl.formatMessage({ id: 'breadcrumb' })}>
            <ul className="breadcrumb">
                {getBreadcrumbData()}
            </ul>
            </nav>
      </div>
    );
};